import { Autocomplete, TextField } from "@mui/material"
import { FC, ReactNode } from "react"
import { infiniteListboxProps } from "@/core/components"
import { useInfiniteSelectList } from "@/core/hooks"
import { store } from "@core/store"
import { ADV } from "../../interfaces"
import { advApi } from "../../store"

export interface IOrderPickerFieldProps {
  value: number[]
  onChange: (orderIds: number[]) => void
}

// {count, pages, data} → Page<T>{items: data, total: count}; offset → page.
const fetchOrdersPage = async ({
  limit,
  offset,
}: {
  limit: number
  offset: number
}) => {
  const request = store.dispatch(
    advApi.endpoints.ordersList.initiate({
      queryParams: { page: Math.floor(offset / limit) + 1, limit },
    }),
  )
  try {
    const res = await request.unwrap()
    return { items: res.data, total: res.count }
  } finally {
    request.unsubscribe()
  }
}

export const OrderPickerField: FC<IOrderPickerFieldProps> = ({
  value,
  onChange,
}) => {
  const orderList = useInfiniteSelectList<ADV.Order>({
    fetchPage: fetchOrdersPage,
    getId: (order) => order.id,
    pageSize: 10,
  })
  const selected = orderList.items.filter((order) => value.includes(order.id))

  return (
    <Autocomplete
      multiple
      options={orderList.items}
      value={selected}
      getOptionLabel={(option: ADV.Order) =>
        `${option.campaign_name} — заказ #${option.id}`
      }
      renderOption={(props, option, state) =>
        [
          props,
          `${option.campaign_name} — заказ #${option.id}`,
          state,
        ] as ReactNode
      }
      isOptionEqualToValue={(option, valueItem) => option.id === valueItem.id}
      filterOptions={(options) => options}
      onChange={(_, values) => onChange(values.map((v) => v.id))}
      noOptionsText={
        orderList.error != null
          ? "Не удалось загрузить список"
          : orderList.items.length === 0
            ? "Нет ордеров"
            : "Ещё..."
      }
      {...infiniteListboxProps({
        hasMore: orderList.hasMore,
        isFetching: orderList.isFetching,
        onLoadMore: orderList.loadMore,
      })}
      renderInput={(params) => (
        <TextField {...params} label="Ордера" variant="outlined" />
      )}
    />
  )
}
